export const v1Migration = {
  version: 1,
   migrate: () => Promise.resolve()
};
